import { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { updateOrRemoveQueryParam } from "@circle-react/helpers/urlHelpers";
import { useRouterQueryParams } from "@circle-react/hooks/useRouterQueryParams";

export const pageQueryName = "page";

interface UsePageQueryReturn {
  initialPage: number;
  page: number;
  setPage: (page: number) => void;
}

export const usePageQuery = (
  initial = 1,
  useQueryParam = true,
): UsePageQueryReturn => {
  const queryParams = useRouterQueryParams();
  const initialPage = Number(queryParams[pageQueryName] || initial);
  const [page, setPage] = useState(initialPage);
  const history = useHistory();

  useEffect(() => {
    if (useQueryParam) {
      history.push({
        search: updateOrRemoveQueryParam(pageQueryName, String(page)),
      });
    }
  }, [page, history, useQueryParam]);

  return { page, setPage, initialPage };
};
